<template>
  <div class="card card-body mt-4">
    <div v-if="supportStore.areIssuesLoaded">
      <BootstrapFlashMessage
        :type="supportStore.success ? 'success' : 'danger'"
        :dismissible="false"
        v-if="supportStore.success !== null"
        @close="() => supportStore.success = null"
      >
        {{ $t(supportStore.success ? 'submit_success' : 'submit_failure') }}
      </BootstrapFlashMessage>

      <div
        id="support-container"
        v-if="supportStore.isTopicSelected || supportStore.isIssueSelected"
      >
        <SupportForm
          :create-support-path="this.createSupportPath"
        />
      </div>

      <div id="vue-support-picker-container" v-else>
        <SupportFormTopicPicker
          @topic-selected="(name) => supportStore.selectTopic(name)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SupportForm from 'components/support/SupportForm.vue';
import SupportFormTopicPicker from 'components/support/SupportTopicPicker.vue';
import BootstrapFlashMessage from 'components/helper/BootstrapFlashMessage.vue';

import { components } from 'locales';
import { useSupportStore } from 'store/support';
import { getURLParam } from 'helper/url';

export default {
  name: 'Support',
  i18n: components.support.Support,
  props: {
    createSupportPath: String,
    issuesPath: String,
  },
  components: {
    BootstrapFlashMessage,
    SupportForm,
    SupportFormTopicPicker,
  },
  setup() {
    const supportStore = useSupportStore();
    return { supportStore };
  },
  async mounted() {
    await this.supportStore.fetchIssues(this.issuesPath);

    // Restore state from URL params
    const urlIssue = getURLParam('issue');
    const urlTopic = getURLParam('topic');

    if (urlIssue) {
      this.supportStore.selectIssue(urlIssue);
    } else if (urlTopic) {
      this.supportStore.selectTopic(urlTopic);
    }
  },
};
</script>

<style scoped>

</style>
